"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ServiceState = {
  CREATED: 'CREATED',
  INITIALIZING: 'INITIALIZING',
  OFFLINE: 'OFFLINE',
  CONNECTING: 'CONNECTING',
  ONLINE: 'ONLINE',
  AUTHENTICATING: 'AUTHENTICATING',
  READY: 'READY',
  ERROR: 'ERROR'
};
var _default = ServiceState;
exports["default"] = _default;